// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2Blqh","footer":"ModalFilter_footer__2DYpt"};